import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import BrandFlag from './BrandFlag';
import styles from './NavigationBar.scss';

export default class TaskBar extends PureComponent {
	static propTypes = {
		brandHref: PropTypes.string.isRequired,
		brandImage: PropTypes.string,
		children: PropTypes.node,
		maxWidth: PropTypes.string,
		onBrandClick: PropTypes.func
	};

	render() {
		const {
			children,
			brandHref,
			brandImage,
			maxWidth,
			onBrandClick
		} = this.props;

		return (
			<header className="c-task-bar">
				<div className={styles.brandFlagContainer} style={{ maxWidth }}>
					<BrandFlag {...{ brandHref, brandImage, onClick: onBrandClick }} />
				</div>
				<div
					className={cx(styles.content, styles.taskContent)}
					style={{ maxWidth }}>
					{children}
				</div>
			</header>
		);
	}
}
